import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Tailwind-collision-aware class merger.
 *
 * Use `cn(...)` in every CVA-driven component so that consumer-supplied
 * `className` overrides (e.g. `<Button className="px-8">`) beat the
 * component's default classes (`px-4`) rather than appearing in addition.
 *
 * The plain `cx(...)` helper still exists for trivial cases where no
 * Tailwind class collision is possible — e.g. joining a base class with
 * a single conditional modifier. Prefer `cn(...)` in any component that
 * accepts a `className` prop.
 */
export function cn(...inputs: readonly ClassValue[]): string {
  return twMerge(clsx(inputs));
}
